(() => {
  const READY = 'data-autoplay-ready';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (!root || root.getAttribute(READY) === '1') return;
    if (String(root.getAttribute('data-autoplay')).toLowerCase() !== 'true') return;
    if (prefersReducedMotion()) return;

    const track = root.querySelector('[id^="Slider-"]');
    if (!track) return;

    const slides = Array.from(track.querySelectorAll(':scope > .slider__slide'));
    if (slides.length < 2) return;

    root.setAttribute(READY, '1');
    track.classList.add('slider--auto-scroll');
    root.classList.add('is-auto-scroll');

    const buttons = root.querySelector('.slider-buttons');
    if (buttons) {
      buttons.hidden = true;
      buttons.style.display = 'none';
    }

    const speedPx = Math.max(20, Number(root.getAttribute('data-autoplay-speed')) || 40);
    let paused = false;
    let inView = true;
    let raf = 0;
    let lastTs = 0;
    let resumeTimer = 0;
    let looping = false;

    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

    const pause = (ms = 5000) => {
      paused = true;
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        paused = false;
        lastTs = 0;
      }, ms);
    };

    root.addEventListener('pointerdown', () => pause(5500), { passive: true });
    root.addEventListener('touchstart', () => pause(5500), { passive: true });
    root.addEventListener(
      'wheel',
      (event) => {
        if (Math.abs(event.deltaX) > 2) pause(4000);
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', () => {
      paused = true;
      window.clearTimeout(resumeTimer);
    });
    root.addEventListener('mouseleave', () => {
      paused = false;
      lastTs = 0;
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          inView = !!(entries[0] && entries[0].isIntersecting);
          if (inView) lastTs = 0;
        },
        { threshold: 0.2, rootMargin: '40px 0px' }
      );
      observer.observe(root);
    }

    const softReset = () => {
      if (looping) return;
      looping = true;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;
      window.requestAnimationFrame(() => {
        looping = false;
        lastTs = 0;
      });
    };

    const tick = (ts) => {
      raf = window.requestAnimationFrame(tick);
      if (!inView || paused || looping) {
        lastTs = 0;
        return;
      }
      if (!lastTs) {
        lastTs = ts;
        return;
      }
      const dt = Math.min(40, ts - lastTs);
      lastTs = ts;

      const max = maxScroll();
      if (max < 8) return;

      const next = track.scrollLeft + (speedPx * dt) / 1000;
      if (next >= max - 1) {
        softReset();
        return;
      }
      track.scrollLeft = next;
    };

    const start = () => {
      lastTs = 0;
      if (!raf) raf = window.requestAnimationFrame(tick);
    };

    const imgs = Array.from(track.querySelectorAll('img'));
    let pending = imgs.filter((img) => !img.complete).length;
    const kick = () => start();
    if (pending === 0) {
      window.setTimeout(kick, 80);
    } else {
      imgs.forEach((img) => {
        if (img.complete) return;
        const done = () => {
          pending -= 1;
          if (pending <= 0) window.setTimeout(kick, 80);
        };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
      window.setTimeout(kick, 1500);
    }
  }

  function boot() {
    document.querySelectorAll('slider-component[data-autoplay="true"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
